import { render, staticRenderFns } from "./GRCRequirementForm.vue?vue&type=template&id=0beb1164&scoped=true&"
import script from "./GRCRequirementForm.vue?vue&type=script&lang=js&"
export * from "./GRCRequirementForm.vue?vue&type=script&lang=js&"
import style0 from "./GRCRequirementForm.vue?vue&type=style&index=0&id=0beb1164&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beb1164",
  null
  
)

export default component.exports